








































































































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import RequiredMarkComponent from "@/components/common/parts/RequiredMarkComponent.vue";
import FormBoxComponent from "@/components/common/form/FormBoxComponent.vue";
import FormRowComponent from "@/components/common/form/FormRowComponent.vue";
import InputTextComponent from "@/components/common/parts/InputTextComponent.vue";
import SelectComponent from "@/components/common/parts/SelectComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { getRoutePath } from "@/router/routes";
import {
  getUsergroupEditApi,
  postUsergroupEditApi
} from "../../typescript/api_client/emesh_api/users/usergroups_edit_api";
import { GetUsergroupEditResponse } from "@/typescript/api_client/emesh_api/users/types";
import {
  getUsergroupAuthorityInfos,
  UsergroupAuthorityInfo
} from "@/typescript/lib/common/get_permission";
export { GetUsergroupEditResponse, UsergroupAuthorityInfo };

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    ContentComponent,
    MenubarComponent,
    RequiredMarkComponent,
    FormBoxComponent,
    FormRowComponent,
    InputTextComponent,
    SelectComponent,
    ButtonComponent,
    ConfirmDialogComponent,
    FooterComponent
  }
})
export default class UserGroupMasterEditPage extends Vue {
  usergroupName: { [s: string]: any } = { value: "", errors: [] };
  usergroupAuthority: { [s: string]: any } = { value: "", errors: [] };
  hasError: boolean = false;
  errorMessages: { [s: string]: string } = {
    required_select: "選択してください",
    required_input: "入力してください"
  };
  isCategoriesVisible: boolean = false;
  authorityInfos: UsergroupAuthorityInfo[] = [];

  isConfirmDialogOpen: boolean = false;

  created() {
    this.setApiData();
  }

  async setApiData() {
    const params = {
      usergroup_id: Number(this.$route.params["usergroup_id"])
    };
    getUsergroupEditApi(params).then((resp: GetUsergroupEditResponse) => {
      this.usergroupName.value = resp.usergroups[0].usergroup_name;
      this.usergroupAuthority.value = resp.usergroups[0].usergroup_authority;
    });
    this.authorityInfos = await getUsergroupAuthorityInfos();
  }

  closeCategory() {
    this.isCategoriesVisible = false;
  }

  setUsergroupName(value: string) {
    this.usergroupName.value = value;
  }

  setAuthority(value: string) {
    this.usergroupAuthority.value = value;
  }

  submit() {
    this.resetError();
    this.validateForm();
    if (this.hasError) return;
    this.save();
  }

  save() {
    const userGroupData = {
      usergroup_id: Number(this.$route.params["usergroup_id"]),
      usergroup_name: this.usergroupName.value,
      usergroup_authority: Number(this.usergroupAuthority.value)
    };

    postUsergroupEditApi(userGroupData).then(() => {
      // UserGroupMasterShowPage に戻る
      const path = getRoutePath("UserGroupMasterShowPage");
      this.$router.push(path);
    });
    return null;
  }

  openDialog() {
    this.isConfirmDialogOpen = true;
  }

  closeConfirm() {
    this.isConfirmDialogOpen = false;
  }

  movePage() {
    this.$router.push(getRoutePath("UserGroupMasterShowPage"));
  }

  //バリデーション関数
  isErrorForm(form) {
    return this[form].errors.length > 0;
  }

  getErrorMessages(form) {
    return this[form].errors;
  }

  validateForm() {
    if (this.usergroupName.value.length == 0) {
      this.addError("usergroupName", "required_input");
    }
    if (this.usergroupAuthority.value === "")
      this.addError("usergroupAuthority", "required_select");
  }

  addError(form, error) {
    let errors = [...this[form].errors];
    errors.push(this.errorMessages[error]);
    this[form].errors = errors;
    this.hasError = true;
  }

  resetError() {
    this.hasError = false;
    const formNames = ["usergroupAuthority", "usergroupName"];
    formNames.forEach(name => {
      this[name].errors = [];
    });
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }
}
